


export type MediaType = 'Document' | 'Image';

export const MediaType = {
    Document: 'Document' as MediaType,
    Image: 'Image' as MediaType
};

